// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32qxZ","colBig":"styles_colBig__Ql2LM","colSmall":"styles_colSmall__2b1H2"};